import * as React from 'react'

function SvgMail({ width = 48, height = 48, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={"0 0 64 64"} {...props}>
      <g transform="matrix(2.6666667 0 0 2.6666667 0 0)">
        <g>
          <path d="M0 0L24 0L24 24L0 24z" stroke="none" fill="none" />
          <path d="M5 6L19 6C 20.10457 6 21 6.8954306 21 8L21 8L21 17C 21 18.10457 20.10457 19 19 19L19 19L5 19C 3.8954306 19 3 18.10457 3 17L3 17L3 8C 3 6.8954306 3.8954306 6 5 6zM18.144424 7.839647L12 11.148183L5.855575 7.839647C 5.490872 7.643268 5.036025 7.779722 4.839647 8.144425C 4.643268 8.509129 4.779722 8.963975 5.144425 9.160354L5.144425 9.160354L11.644425 12.660354C 11.866407 12.779882 12.133593 12.779882 12.355575 12.660354L12.355575 12.660354L18.855576 9.160354C 19.220278 8.963975 19.356731 8.509129 19.160353 8.144425C 18.963974 7.779722 18.509129 7.643268 18.144424 7.839647z" stroke="none" fill="currentColor" fillRule="nonzero" />
        </g>
      </g>
    </svg>
  )
}

export default SvgMail
